export const MENU_ITEMS = [
	// { id: 'faq', path: '/faq', feature: 'freja-faq' },
	{ id: 'support', path: '/support' },
	// {
	// 	id: 'guide',
	// 	path: '/guide/support',
	// 	label: ['guide.box.title', 'guide.box.support.title'],
	// },
];
